import React, {useEffect, useState} from "react"
import {connect} from "react-redux";
import Dashboard from "../../admin/components/dashboard/Dashboard";
import Compte from "../../admin/components/dashboard/Compte";
import useWindowSize from "../utilities/UseWindowSize";

const CenterMainSection = (props)=>{

    const [paddingLeft, setPaddingLeft] = useState()
    const [alternateBackground, setAlternateBackground] = useState()
    const [alternateWraper, setAlternateWraper] = useState()
    const [windowSize, setWindowSize] = useState(null)
    const [width, height] = useWindowSize()

    const [mainWrarperStyle, setMainWrarperStyle] = useState(
        {
            "position":"absolute",
            "left": "0",
            "top": "0",
            'height': '100%',
            "width": "100%",
            "display":"flex",
        }
    )

    const mainAlternateWrarperStyle = {
        'height': '100%',
        "width": "100%",
        "position":"absolute",
        "display":"flex",
        "zIndex": "100000000000",
        "left": "0",
        "top": "0"
    }

    let mainCenterStyle = {
        "position":"absolute",
        "left": "0",
        "top": "0",
        "width": "100%",
        "height": "100%",
        "color" : "var(--theme-color)",
        //"paddingTop": "30px",
        "backgroundColor": "#454756",//"var(--theme-page-background)",
        "zIndex": "1"
    }

    let mainCenterStyleAlternate = {
        "width": "100%",
        "height": "100%",
        "color" : "var(--theme-color)",
        "backgroundColor": '#00000097',
        "zIndex": "100000"
    }

    useEffect(()=>{

       setWindowSize(window.innerWidth)
        setAlternateBackground(mainCenterStyle);
        setAlternateWraper(mainWrarperStyle);
    }, [])

    useEffect(()=>{

    }, [width])

    useEffect(() => {
        const path = window.location.pathname;
        if (path === '/dashbboard') {
            console.log("plop", path);
            props.navigateTo('dashboard');
        }
    }, [props]);

    useEffect(() => {

    }, [props.leftNavWidth, alternateBackground, props.showCenterSection])

    useEffect(()=>{
        (props.currentPage === 'product' || props.showCurrentSection==='product')?setAlternateWraper(mainAlternateWrarperStyle):setAlternateWraper(mainWrarperStyle);
        (props.currentPage === 'product' || props.showCurrentSection==='product')?setAlternateBackground(mainCenterStyleAlternate):setAlternateBackground(mainCenterStyle);

    },[props.showCurrentSection, props.currentPage])

    return (
        <>
        {(props.showCenterSection)?
            <div style={alternateWraper}  >
                <div id="center-one" style={alternateBackground} >

                    {(props.showCurrentSection==='profil')?
                        <Profil />
                        :<Dashboard />
                    }
                </div>
            </div>
            :null
            }
        </>
    )
}


const mapStateToProps = state => {
    return {
        userId: state.MeReducer.id,
        leftNavWidth : state.LeftPanelReducer.leftNavWidth,
        showCurrentSection: state.LeftPanelReducer.showCurrentSection,
        currentPage: state.DashboardReducer.current_page,
        showCenterSection: state.LeftPanelReducer.showCenterSection

    }
}

const mapDispatchTProps = dispatch => {
    return {
        navigateTo : (e)=> dispatch({type: 'SET_CURRENT_PAGE', data:e}),
    }
}

export default connect(mapStateToProps, mapDispatchTProps)(CenterMainSection);
